import request from '#/utils/request';
import { parseVer4TreeResponse } from '#/api/adapters/envelope';

/**
 * 工單預計 SN 標籤送印工作列表（無分頁；終態保留 24 小時後清除）。
 * GET `/mom/work-order/{id}/sn-label-jobs`
 */
export async function fetchWorkOrderSnLabelJobs(workOrderId) {
  const { data: raw } = await request.get(`/mom/work-order/${workOrderId}/sn-label-jobs`);
  return parseVer4TreeResponse(raw);
}
